import { useQuery } from "@tanstack/react-query";

import { getProjectOwners } from "../api/getProjectOwners";

export const useProjectOwners   = (orgUuid?: string) =>
  useQuery({
    queryKey: ["project-owners", orgUuid],
    queryFn: () => {
      if (!orgUuid) {
        throw new Error("Missing Ord Id");
      }
      return getProjectOwners(orgUuid);
    },
    enabled: Boolean(orgUuid), // 🔥 prevents premature call
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
